import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PromptedLink({ to, isDirty, children, ...rest }) {
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (isDirty) {
      e.preventDefault();
      if (
        window.confirm(
          "You have unsaved changes. Are you sure you want to leave?",
        )
      ) {
        navigate(to);
      }
    }
  };
  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
